<template>
    <video controls class="flex-grow-1" :src="src" style="object-fit: contain; max-width: 100%;"/>
</template>

<script>
    export default {
        name: "VideoViewer",
        props: {
            src: {
                required: true,
                type: String
            }
        }
    }
</script>

<style scoped>

</style>
